// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qDK9","fullView":"styles_fullView__1noA3"};